module.exports = __webpack_public_path__ + "img/deviceStopped.c5bb7392.svg";